module.exports = __webpack_public_path__ + "assets/img/power-plus.f6583f22.png";